<div class="offer-header">
	<div class="title">
		<h3>{{ translateTitle() ? (title() | translate) : title() }}</h3>
	</div>
	@if (lines().length > 0) {
		<div class="description">
			@for (line of lines(); track line) {
				<b>{{ line }}</b>
			}
		</div>
	}
</div>
